import React from "react";
import { ToggleButton } from "@mui/lab";
import styled from "styled-components";

const StyledToggleButton = styled(ToggleButton)`
    font-size: 12px;
    text-transform: none;
    font-weight: 300;
    width: 150px;
`;

const ButtonContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin: -6px;
    & > * {
        margin: 6px;
    }
`;

const ConfigCategoryToggle = ({
    selectedCategory,
    setSelectedCategory,
    setConfigurationDataGeneral,
}) => {
    const handleChange = (event, newCategory) => {
        if (newCategory !== null) {
            setSelectedCategory(newCategory);
        }
    };
    const handleCleanup = () => {
        setConfigurationDataGeneral({
            deployments: {
                environment: undefined,
            },
            releases: {
                latest: undefined,
                name: undefined,
            },
            pipelines: {
                branch: undefined,
                stage: undefined,
                job: undefined,
            },
            webhook: false,
        });
    };

    return (
        <ButtonContainer>
            <StyledToggleButton
                value="general"
                selected={selectedCategory === "general"}
                onClick={() => {
                    handleChange(null, "general");
                    handleCleanup();
                }}
            >
                General settings
            </StyledToggleButton>
            <StyledToggleButton
                value="repo"
                selected={selectedCategory === "repo"}
                onClick={() => {
                    handleChange(null, "repo");
                    handleCleanup();
                }}
            >
                Per Repo settings
            </StyledToggleButton>
        </ButtonContainer>
    );
};

export default ConfigCategoryToggle;
